import angular from 'angular';
import { InputChavePixController } from './input-chave-pix.controller';

export class InputChavePixComponent implements angular.IComponentOptions {
    static selector = 'inputChavePix';
    static controller = InputChavePixController;
    static template = require('!!html-loader!./input-chave-pix.html');
    static transclude = false;
    static bindings = {
      tipo: '<',
      ngModel: '=',
      ngDisabled: '<?',
      ngRequired: '<?',
      ngChange: '&?',
      formRef: '<'
    };
}
